<template>
  <div v-if="group != null" id="show-migrate-group-builtin">
    <v-card>
      <v-card-title>
        Migrer le groupe avec un Template prédéfini en V5
      </v-card-title>
      <v-card-text>
        <div>
          <v-dialog v-model="dialogForMigrateGroup" persistent>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                class="primary"
                style="max-width: 100%"
                :disabled="
                  isGroupMigrableParent != null &&
                  (isGroupMigrableParent.facebook || isGroupMigrableParent.pms)
                "
              >
                <span v-if="$vuetify.breakpoint.width >= 800">
                  Migrer le groupe avec un Template prédéfini en V5</span
                >
                <span
                  v-if="
                    $vuetify.breakpoint.width > 600 &&
                    $vuetify.breakpoint.width < 800
                  "
                  >Migrer avec un Template prédéfini en V5</span
                >
                <span v-if="$vuetify.breakpoint.width <= 600"
                  >Migrer vers la V5</span
                >
              </v-btn>
              <p
                v-if="
                  isGroupMigrableParent != null &&
                  isGroupMigrableParent.facebook
                "
              >
                Le groupe est configuré avec Facebook, option non supportée sur
                les V5.
              </p>
              <p
                v-if="
                  isGroupMigrableParent != null && isGroupMigrableParent.pms
                "
              >
                Le groupe est configuré avec la PMS, option non supportée sur
                les V5.
              </p>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline"
                  >Migrer le groupe avec un Template prédéfini en V5</span
                >
              </v-card-title>
              <v-card-text>
                <v-alert type="warning">
                  La migration du groupe, migre également tous les portails
                  configurés en "héritage groupe" appartenant à ce groupe.
                </v-alert>
                <v-form>
                  Actuellement le Template utilisé est:
                  <b>{{ group.portalOptions.name }}</b>
                  <v-select
                    v-model="portalProfile"
                    label="Liste des templates définis"
                    :items="portalProfiles"
                    item-value="id"
                    item-text="name"
                  >
                  </v-select>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialogForMigrateGroup = false"
                  >Fermer</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="
                    [
                      migrateGroup(group.id, portalProfile),
                      (dialogForMigrateGroup = false),
                    ]
                  "
                  >Migrer le groupe et ses portails</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, ref, toRefs } from "@vue/composition-api";
import { useMigrationPortal } from "../../composables/migation-portal";
import { usePortalProfile } from "../../composables/portal-profile";

export default {
  props: {
    group: Object,
    isGroupMigrableParent: Object,
  },
  setup(props) {
    const { migrationPortalData, migrateGroup } = useMigrationPortal();
    const { portalProfiles, listPortalProfileV5 } = usePortalProfile();
    onMounted(() => {
      listPortalProfileV5(props.group.partner.id);
    });

    return {
      migrateGroup,
      dialogForMigrateGroup: ref(false),
      ...toRefs(migrationPortalData),
      portalProfiles,
      portalProfile: ref(null),
    };
  },
};
</script>
